import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Home from '@/pages/Home';
import Bookmarks from '@/pages/Bookmarks';
import Todos from '@/pages/Todos';
import Settings from '@/pages/Settings';
import Sidebar from '@/components/Sidebar';
import { useTheme } from '@/hooks/useTheme';

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isExtensionEnv = typeof window !== 'undefined' && window.location.protocol === 'chrome-extension:';
  const [isSidePanel, setIsSidePanel] = React.useState(isExtensionEnv && window.innerWidth < 500);
  const [isMobileWeb, setIsMobileWeb] = React.useState(!isExtensionEnv && window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSidePanel(isExtensionEnv && window.innerWidth < 500);
      setIsMobileWeb(!isExtensionEnv && window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isExtensionEnv]);

  // Only redirect to bookmarks in extension side panel mode
  useEffect(() => {
    if (isSidePanel && location.pathname === '/') {
        navigate('/bookmarks', { replace: true });
    } else if (isMobileWeb && location.pathname === '/') {
        navigate('/todos', { replace: true });
    }
  }, [isSidePanel, isMobileWeb, location.pathname, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 transition-colors duration-300">
       {/* Global Sidebar - Hide in Side Panel */}
      {!isSidePanel && !isMobileWeb && <Sidebar />}
      
      {/* Main Content Area - Adjust padding based on mode */}
      <main className={isSidePanel || isMobileWeb ? 'p-0' : 'pl-24'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bookmarks" element={<Bookmarks />} />
          <Route path="/todos" element={<Todos />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
};

const App = () => {
  useTheme();
  
  return (
    <Router>
      <Routes>
        <Route path="*" element={<AppContent />} />
      </Routes>
    </Router>
  );
};

export default App;
